import { Button, Form, Row, Badge, Image } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

import FormContainer from "../components/FormContainer";
import Loader from "../components/Loader";
import { useUpdateAttendanceMutation } from "../slices/attendanceSlice";
import welcomeMessage from "../assets/audios/messageTone.mp3";
import errorTone from "../assets/audios/error_tone.mp3";
import { setCredentials } from "../slices/authSlice";
import ProfileImage from "../components/ProfileImage";
import demoPic from "../assets/GymThreadmill.jpeg";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../slices/gymSlice";
import { logout } from "../slices/authSlice";

const AttendanceScreenForUsers = () => {
  const [userId, setUserId] = useState();
  const { userInfo } = useSelector((state) => state.auth);
  const [trendsVisible, setTrendsVisible] = useState(
    userInfo.trendsVisible ? userInfo.userInfo : true
  );
  const [refreshTrend, setRefreshTrend] = useState(false);
  const [currentUsersAtGym, setCurrentUsersAtGym] = useState(0);

  const [updateAttendance, { isLoading }] = useUpdateAttendanceMutation();

  const [isToggled, setIsToggled] = useState(userInfo.audioOn);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleToggle = () => {
    setIsToggled(!isToggled);
    dispatch(setCredentials({ ...userInfo, audioOn: !isToggled }));
  };

  const [logoutApi] = useLogoutMutation();
  let gymId;
  if (userInfo) {
    gymId = userInfo?.gymId?._id;
  }

  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();
      dispatch(logout());
      navigate("/login");
      toast.success("Successfully logged out");
    } catch (err) {
      console.log(err);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!userInfo) toast.error("Please login to use the application");
    if (
      userId?.toString().toLowerCase().length < 1 ||
      userId?.toString().toLowerCase().length > 7 ||
      !userId
    )
      toast.error("Please enter valid Member Id");
    else {
      try {
        const res = await updateAttendance({
          payLoad: {
            userId: userId?.toString().toLowerCase(),
          },
          token: userInfo.token,
        }).unwrap();
        if (res.subsAlreadyExpired) {
          toast.error(
            () => (
              <div
                style={{
                  width: "550px",
                  padding: "20px",
                  fontSize: "1.2em",
                  lineHeight: "1.5",
                  backgroundColor: "red",
                }}
              >
                <audio
                  src={errorTone}
                  type="audio/mp3"
                  autoPlay={isToggled}
                ></audio>
                <ProfileImage
                  style={{ width: "500px", height: "auto", margin: "10px 0" }}
                  imageId={userInfo?.gymId._id + "" + res?.userId}
                />{" "}
                <br></br>
                <label style={{ color: "white" }}>
                  Subscription EXPIRED on : {res?.expiresOn?.split("T")[0]}
                </label>{" "}
                <br></br>
              </div>
            ),
            {
              style: { width: "600px" }, // Increase the width of the toast itself
            }
          );
          setRefreshTrend(!refreshTrend);
        } else {
          toast.success(
            () => (
              <div
                style={{
                  width: "550px",
                  padding: "20px",
                  fontSize: "1.2em",
                  lineHeight: "1.5",
                }}
              >
                <audio
                  src={welcomeMessage}
                  type="audio/mp3"
                  autoPlay={isToggled}
                ></audio>
                <ProfileImage
                  style={{ width: "500px", height: "auto", margin: "10px 0" }}
                  imageId={userInfo.gymId._id + "" + res?.userId}
                />
                <br />
                <strong>
                  {res?.message} {res?.userName}
                </strong>
                <br />
                Valid Till: {res?.expiresOn?.split("T")[0]}
                <br />
                Expires in:{" "}
                {Math.ceil(
                  (new Date(res?.expiresOn) - new Date()) /
                    (1000 * 60 * 60 * 24)
                )}{" "}
                days
              </div>
            ),
            {
              style: { width: "600px" }, // Increase the width of the toast itself
            }
          );
          setRefreshTrend(!refreshTrend);
        }
        setUserId("");
      } catch (err) {
        err.status === "PARSING_ERROR" || err.status === 400
          ? toast.error(() => (
              <div>
                <audio
                  src={errorTone}
                  type="audio/mp3"
                  autoPlay={isToggled}
                ></audio>
                <br />
                Please enter valid Member ID
              </div>
            ))
          : toast.error(err.error);
      }
    }
  };

  const showHideTrends = async () => {
    setTrendsVisible(!trendsVisible);
    dispatch(
      setCredentials({
        ...userInfo,
        trendsVisible,
      })
    );
  };

  // const imageId = 940310014;
  // const cacheBuster = new Date().getTime();

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "99vh",
          marginTop: "30px",
        }}
      >
        <Image
          style={{ borderRadius: "10px" }}
          width="300"
          height="250"
          src={`https://zpottergym.s3.ap-south-1.amazonaws.com/GymProfilePic/gym${userInfo?.gymId?._id}.jpg`}
          alt="1sAndOs"
          fluid
        />
        <FormContainer>
          <Form onSubmit={submitHandler}>
            <Form.Group className="my-1" controlId="userId">
              <Form.Label id="userId"></Form.Label>
              <Form.Control
                style={{ height: "50px" }}
                type="text"
                placeholder="Member Id"
                autoComplete="off"
                autoFocus
                value={userId || ""}
                onChange={(e) => {
                  // Update userId only if input is alphanumeric (no special characters)
                  const newValue = e.target.value.replace(/[^a-zA-Z0-9]/g, ""); // Allow only letters and numbers
                  setUserId(newValue);
                }}
              />
            </Form.Group>
            <br />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                className={`${userInfo.themeColor}ThemeHeaderTop`}
                type="submit"
                variant="primary"
              >
                Submit
              </Button>
            </div>
            {isLoading && <Loader />}
          </Form>
        </FormContainer>

        <>
          <button
            style={{ borderRadius: "8px", marginTop: "50px" }}
            onClick={handleToggle}
          >
            Sound : <b>{isToggled ? "ON" : "OFF"}</b>
          </button>
        </>

        <div style={{ marginTop: "100px" }}>
          <button
            style={{ borderRadius: "8px", marginTop: "50px" }}
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default AttendanceScreenForUsers;
